/** Ukrainian month names in the genitive case: "12 листопада". */
const MONTHS_GENITIVE = [
  'січня',
  'лютого',
  'березня',
  'квітня',
  'травня',
  'червня',
  'липня',
  'серпня',
  'вересня',
  'жовтня',
  'листопада',
  'грудня',
] as const;

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Parses a calendar date "YYYY-MM-DD" without any time zone conversion. */
export function parseIsoDate(value: string): { year: number; month: number; day: number } {
  const m = ISO_DATE.exec(value);
  if (!m) throw new Error(`Invalid ISO date: ${value}`);
  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) throw new Error(`Invalid ISO date: ${value}`);
  return { year, month, day };
}

/** "2026-11-12" → "~12 листопада" (post text, spec 6.1). */
export function formatEtaLong(isoDate: string): string {
  const { month, day } = parseIsoDate(isoDate);
  return `~${day} ${MONTHS_GENITIVE[month - 1]}`;
}

/** "2026-11-12" → "~12.11" (pinned list and fleet list, spec 6.1). */
export function formatEtaShort(isoDate: string): string {
  const { month, day } = parseIsoDate(isoDate);
  return `~${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}`;
}

/** Today's calendar date in Kyiv as "YYYY-MM-DD". */
export function kyivToday(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Kyiv',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}
